export const copyToClipboard = (text: string | number): void => { 
  navigator.clipboard.writeText(text.toString());
};
